// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file agency/v1/agency.proto (package agency.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Direction, PageRequest, PageResponse } from "../../tsam/v1/page_pb";
import { file_tsam_v1_page } from "../../tsam/v1/page_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agency/v1/agency.proto.
 */
export const file_agency_v1_agency: GenFile = /*@__PURE__*/
  fileDesc("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", [file_tsam_v1_page]);

/**
 * @generated from message agency.v1.ListRequest
 */
export type ListRequest = Message<"agency.v1.ListRequest"> & {
  /**
   * @generated from field: tsam.v1.PageRequest page = 1;
   */
  page?: PageRequest;

  /**
   * @generated from field: agency.v1.SortRequest sort = 2;
   */
  sort?: SortRequest;
};

/**
 * Describes the message agency.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 0);

/**
 * @generated from message agency.v1.SortRequest
 */
export type SortRequest = Message<"agency.v1.SortRequest"> & {
  /**
   * @generated from field: agency.v1.Field field = 1;
   */
  field: Field;

  /**
   * @generated from field: tsam.v1.Direction direction = 2;
   */
  direction: Direction;
};

/**
 * Describes the message agency.v1.SortRequest.
 * Use `create(SortRequestSchema)` to create a new message.
 */
export const SortRequestSchema: GenMessage<SortRequest> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 1);

/**
 * @generated from message agency.v1.ListResponse
 */
export type ListResponse = Message<"agency.v1.ListResponse"> & {
  /**
   * @generated from field: repeated agency.v1.Agency agencies = 1;
   */
  agencies: Agency[];

  /**
   * @generated from field: tsam.v1.PageResponse page = 2;
   */
  page?: PageResponse;
};

/**
 * Describes the message agency.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 2);

/**
 * @generated from message agency.v1.OnboardRequest
 */
export type OnboardRequest = Message<"agency.v1.OnboardRequest"> & {
  /**
   * @generated from field: agency.v1.Credentials agency_credentials = 1;
   */
  agencyCredentials?: Credentials;

  /**
   * @generated from field: string config_id = 2;
   */
  configId: string;

  /**
   * @generated from field: string agency_alias = 3;
   */
  agencyAlias: string;
};

/**
 * Describes the message agency.v1.OnboardRequest.
 * Use `create(OnboardRequestSchema)` to create a new message.
 */
export const OnboardRequestSchema: GenMessage<OnboardRequest> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 3);

/**
 * @generated from message agency.v1.OnboardResponse
 */
export type OnboardResponse = Message<"agency.v1.OnboardResponse"> & {
  /**
   * @generated from field: agency.v1.Agency agency = 1;
   */
  agency?: Agency;
};

/**
 * Describes the message agency.v1.OnboardResponse.
 * Use `create(OnboardResponseSchema)` to create a new message.
 */
export const OnboardResponseSchema: GenMessage<OnboardResponse> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 4);

/**
 * @generated from message agency.v1.Credentials
 */
export type Credentials = Message<"agency.v1.Credentials"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: string instance_url = 3;
   */
  instanceUrl: string;

  /**
   * @generated from field: string oauth_url = 4;
   */
  oauthUrl: string;
};

/**
 * Describes the message agency.v1.Credentials.
 * Use `create(CredentialsSchema)` to create a new message.
 */
export const CredentialsSchema: GenMessage<Credentials> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 5);

/**
 * @generated from message agency.v1.AvailableConfigsRequest
 */
export type AvailableConfigsRequest = Message<"agency.v1.AvailableConfigsRequest"> & {
  /**
   * @generated from field: agency.v1.Credentials agency_credentials = 1;
   */
  agencyCredentials?: Credentials;
};

/**
 * Describes the message agency.v1.AvailableConfigsRequest.
 * Use `create(AvailableConfigsRequestSchema)` to create a new message.
 */
export const AvailableConfigsRequestSchema: GenMessage<AvailableConfigsRequest> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 6);

/**
 * @generated from message agency.v1.AvailableConfigsResponse
 */
export type AvailableConfigsResponse = Message<"agency.v1.AvailableConfigsResponse"> & {
  /**
   * @generated from field: repeated agency.v1.Config configs = 1;
   */
  configs: Config[];
};

/**
 * Describes the message agency.v1.AvailableConfigsResponse.
 * Use `create(AvailableConfigsResponseSchema)` to create a new message.
 */
export const AvailableConfigsResponseSchema: GenMessage<AvailableConfigsResponse> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 7);

/**
 * @generated from message agency.v1.Config
 */
export type Config = Message<"agency.v1.Config"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string provider_name = 2;
   */
  providerName: string;
};

/**
 * Describes the message agency.v1.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema: GenMessage<Config> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 8);

/**
 * @generated from message agency.v1.Agency
 */
export type Agency = Message<"agency.v1.Agency"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled: boolean;

  /**
   * @generated from field: string provider_name = 3;
   */
  providerName: string;

  /**
   * @generated from field: string created_at = 4;
   */
  createdAt: string;

  /**
   * @generated from field: repeated string caisses_names = 5;
   */
  caissesNames: string[];

  /**
   * @generated from field: string instance_url = 6;
   */
  instanceUrl: string;

  /**
   * @generated from field: string logo = 7;
   */
  logo: string;

  /**
   * @generated from field: string contact_email = 8;
   */
  contactEmail: string;

  /**
   * @generated from field: string after_sales_email = 9;
   */
  afterSalesEmail: string;

  /**
   * @generated from field: bool is_treep_recap_enabled = 10;
   */
  isTreepRecapEnabled: boolean;

  /**
   * @generated from field: string treep_recap_phone_number = 11;
   */
  treepRecapPhoneNumber: string;

  /**
   * @generated from field: string billing_client_name = 12;
   */
  billingClientName: string;

  /**
   * @generated from field: string alias = 13;
   */
  alias: string;

  /**
   * @generated from field: string opening_hours = 14;
   */
  openingHours: string;
};

/**
 * Describes the message agency.v1.Agency.
 * Use `create(AgencySchema)` to create a new message.
 */
export const AgencySchema: GenMessage<Agency> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 9);

/**
 * @generated from message agency.v1.AgencyInfo
 */
export type AgencyInfo = Message<"agency.v1.AgencyInfo"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;

  /**
   * @generated from field: string opening_hours = 3;
   */
  openingHours: string;

  /**
   * @generated from field: string contact_phone = 4;
   */
  contactPhone: string;

  /**
   * @generated from field: string contact_email = 5;
   */
  contactEmail: string;

  /**
   * @generated from field: agency.v1.ConversationalModule conversational_module = 6;
   */
  conversationalModule?: ConversationalModule;
};

/**
 * Describes the message agency.v1.AgencyInfo.
 * Use `create(AgencyInfoSchema)` to create a new message.
 */
export const AgencyInfoSchema: GenMessage<AgencyInfo> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 10);

/**
 * @generated from message agency.v1.ConversationalModule
 */
export type ConversationalModule = Message<"agency.v1.ConversationalModule"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message agency.v1.ConversationalModule.
 * Use `create(ConversationalModuleSchema)` to create a new message.
 */
export const ConversationalModuleSchema: GenMessage<ConversationalModule> = /*@__PURE__*/
  messageDesc(file_agency_v1_agency, 11);

/**
 * @generated from enum agency.v1.Field
 */
export enum Field {
  /**
   * @generated from enum value: FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIELD_ID = 1;
   */
  ID = 1,
}

/**
 * Describes the enum agency.v1.Field.
 */
export const FieldSchema: GenEnum<Field> = /*@__PURE__*/
  enumDesc(file_agency_v1_agency, 0);

/**
 * @generated from service agency.v1.AgencyService
 */
export const AgencyService: GenService<{
  /**
   * @generated from rpc agency.v1.AgencyService.Onboard
   */
  onboard: {
    methodKind: "unary";
    input: typeof OnboardRequestSchema;
    output: typeof OnboardResponseSchema;
  },
  /**
   * @generated from rpc agency.v1.AgencyService.AvailableConfigs
   */
  availableConfigs: {
    methodKind: "unary";
    input: typeof AvailableConfigsRequestSchema;
    output: typeof AvailableConfigsResponseSchema;
  },
  /**
   * @generated from rpc agency.v1.AgencyService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agency_v1_agency, 0);

